var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerOff = function SvgPowerOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6 3v-.6h-1.2v10.8h1.2V3m-8.1 9A7.5 7.5 0 0 1 8.56 5.333L8.01 4.268A8.701 8.701 0 0 0 12 20.7a8.701 8.701 0 0 0 3.99-16.432l-.551 1.065A7.5 7.5 0 0 1 19.499 12c0 4.144-3.355 7.5-7.5 7.5A7.5 7.5 0 0 1 4.5 12"
  })));
};
export default SvgPowerOff;